import { render } from "./RawDataAccess.vue?vue&type=template&id=5274f093&scoped=true"
import script from "./RawDataAccess.vue?vue&type=script&lang=js"
export * from "./RawDataAccess.vue?vue&type=script&lang=js"

import "./RawDataAccess.vue?vue&type=style&index=0&id=5274f093&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5274f093"]])

export default __exports__